<template>
  <div :class="['home', { 'home-br': isNewLandingpage }]">
    <div
      v-for="(item, idx) in form"
      :key="idx"
      :class="[{ 'has-padding': ['img-link'].includes(item.type) }]"
    >
      <component
        :is="getCom(item)"
        :form-item="item || {}"
        :rely-key-item="relyKeyItem(idx)"
        :isCanSubmit="isCanSubmit"
        :phoneNumber="phoneNumber"
        :product="product"
        :identity="identity"
        :areaId="areaId"
        :policy="policy"
        :idx="idx"
        :omega-item="omegaItem"
        :phoneClassError="phoneClassError"
        :areaClassError="areaClassError"
        :policyClassError="policyClassError"
        :policyClassCircle="policyClassCircle"
        @form-update="formUpdate"
        @refresh="getPageConfig"
        @doLoginBr="doLoginBr"
        :cm="true"
      ></component>
    </div>
    <!-- <stay-pop></stay-pop> -->
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../tools/request";
import {
  fireBase,
  getEnd,
  getLocation,
  computeStayTime,
  computeJumpTime,
} from "../tools/utils";
import {
  showDialog,
  showAlertDialog,
  showLoadingToast,
  showToast,
} from "../tools/Tip";
import { ends, LOGIN_CONFIG, SUPPORT_COUNTRY as sc } from "../tools/constant";

import WAHeader from "../components/loginComp/wa-header.vue";
import WAFooter from "../components/loginComp/wa-footer.vue";
import HomeBanner from "../components/loginComp/home-banner.vue";
import PhoneInput from "../components/loginComp/phone-input.vue";
import Policy from "../components/loginComp/policy.vue";
import RegisterBtn from "../components/loginComp/register-btn.vue";
import BottomSelect from "../components/loginComp/bottom-select.vue";
import CitySelect from "../components/loginComp/city-select.vue";
import MultiBanner from "../components/loginComp/multi-banner.vue";
import Banner from "../components/loginComp/banner.vue";
import ImgLink from "../components/base/img-link";
import DriverInfo from "../components/loginComp/driver-info.vue";
import BottomIcon from "../components/loginComp/bottom-icon.vue";
import DgdBanner from "../components/loginComp/dgd-banner.vue";
import ChannelBanner from "../components/loginComp/channel-banner.vue";
import CustomBanner from "../components/base/custom-banner.vue";
// import StayPop from "../components/loginComp/stay-pop.vue"

const REG_PHONE_NUM = /^\d+$/;
export default {
  name: "loginMxComp",
  data() {
    return {
      phoneNum: "",
      isAgree: false,
      phoneNumValidate: false,
      form: [],
      agreeList: [],
      has_reward_banner: false,
      banner_config: {},
      page_style: "",
      phoneClassError: false,
      areaClassError: false,
      policyClassError: false,
      policyClassCircle: false,
      hasCity: false,
    };
  },
  computed: {
    ...mapState([
      "_ticket",
      "_login_btn_text",
      "_phone_focus_global",
      "_area",
      "_cell",
      "_uuid",
      "_open_type",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path",
      "_product_name",
      "_login_config",
    ]),
    params() {
      return new URLSearchParams(location.search);
    },
    isPreviewPage() {
      return this.params.get("ob_page_type") === "preview";
    },
    isNewLandingpage() {
      return this.page_style === "h5_br" || this.page_style === "whatsapp_br";
    },
    location_country() {
      return this.params.get("location_country");
    },
    phoneCountryCode() {
      return LOGIN_CONFIG[this.location_country].country_calling_code;
    },
    isWhatsApp() {
      // return false;
      return (
        this.params.get("end") === "WhatsappEnd" ||
        this.params.get("from_end") === "WhatsappConf"
      );
    },
    oid() {
      return this.params.get("oid") || Omega.getOmgid();
    },
    omegaItem() {
      return {
        bis_id: this.params.get("bis_id") || "",
        channel: this.params.get("channel") || "",
        end: getEnd(),
        oid: this.oid,
        whatsapp: this.isWhatsApp ? +this.isWhatsApp : 0,
        city_id: this._area.value || this.areaId || "",
        country_code: this.phoneCountryCode,
        country: this.location_country,
        a: this.params.get("a") || "", // dgd活动id
        scene: this.params.get("scene") || "", // 新旧dgd
        i: this.params.get("i") || "", // 推荐人ID-加密后的
        shar_chanl: this.params.get("shar_chanl") || "", // 分享渠道
      };
    },
    relyKeyItem() {
      return (idx) => {
        let other_key = (this.form[idx] || {}).outer_key;
        if (!other_key) {
          return null;
        } else {
          return (this.form.filter((item) => other_key === item.key) || [])[0];
        }
      };
    },
    phoneNumber() {
      if (this.isNewLandingpage) {
        let phone_enter_region_list =
          (this.form.filter((x) => x.type === "phone-enter-region")[0] || {})
            .list || [];
        this.policyClassError = false;
        this.policyClassCircle = false;
        return (
          phone_enter_region_list.filter((x) => x.type === "phone-enter")[0] ||
          {}
        ).value;
      } else {
        return (this.form.filter((x) => x.type === "phone-enter")[0] || {})
          .value;
      }
    },
    product() {
      if (this.isNewLandingpage) {
        let phone_enter_region_list =
          (this.form.filter((x) => x.type === "phone-enter-region")[0] || {})
            .list || [];
        return (
          (phone_enter_region_list.filter((x) => x.key === "product")[0] || {})
            .value || ""
        );
      } else {
        return (
          (this.form.filter((x) => x.key === "product")[0] || {}).value || ""
        );
      }
    },
    identity() {
      if (this.isNewLandingpage) {
        let phone_enter_region_list =
          (this.form.filter((x) => x.type === "phone-enter-region")[0] || {})
            .list || [];
        return (
          (phone_enter_region_list.filter((x) => x.key === "identity")[0] || {})
            .value || ""
        );
      } else {
        return (
          (this.form.filter((x) => x.key === "identity")[0] || {}).value || ""
        );
      }
    },
    areaId() {
      this.policyClassError = false;
      this.policyClassCircle = false;
      return (
        (this.form.filter((x) => x.key === "area_id")[0] || {}).value || ""
      );
    },
    privacy_policy() {
      return (
        (this.form.filter((x) => x.type === "button")[0] || {})
          .privacy_options || []
      );
    },
    policy() {
      // new landingpage 提交按钮上方的法律条款组件, 和提交按钮在一个大组件内
      return this.privacy_policy.every((o) =>
        o.required === false ? true : o.value
      );
    },
    policyChoosedType() {
      return this.privacy_policy.reduce((accumulator, current) => {
        if (current.term_type && current.value) {
          accumulator.push(current.term_type);
        }
        return accumulator;
      }, []);
    },
    isCanSubmit() {
      // 不是new landingpage的页面才会需要这个判断, new landingpage页面一直高亮
      let needCheck = ["phone-enter", "select", "privacy-policy"];
      return this.form
        .filter((x) => needCheck.includes(x.type))
        .every((x) =>
          x.type === "privacy-policy"
            ? x.options.every((o) => o.value)
            : x.value
        );
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    phoneFocus() {
      this._phone_focus_global && this.$refs.phone_input.focus();
    },
    //接收各组件发送的更新emit
    formUpdate(idx) {
      this.$set(this.form, idx, this.form[idx]);
      this.$emit("btn-update");
    },
    getCom(item) {
      if (item.type === "select" && item.align === "right") {
        return CitySelect;
      } else {
        return {
          "rotation-banner": HomeBanner,
          reward_banner: CustomBanner,
          "phone-enter": PhoneInput,
          "privacy-policy": Policy,
          button: RegisterBtn,
          select: BottomSelect,
          header: WAHeader,
          footer: WAFooter,
          "multi-banner": MultiBanner,
          banner: Banner,
          "img-link": ImgLink,
          "phone-enter-region": DriverInfo,
          bottom_icon: BottomIcon,
          "dgd-banner": DgdBanner,
          "multi-channel-banner": ChannelBanner,
        }[item.type];
      }
    },
    getPageConfig(changeType) {
      if (changeType !== "city") {
        showLoadingToast(this, this.$t("加载中"));
      }
      let up = new URLSearchParams(window.location.search);
      if (this.isPreviewPage) {
        up.set("page", "jobs_landing_page_conf");
      }
      if (this._area.value) {
        up.set("area_id", this._area.value);
      }
      let LOGIN_INFO_CONF = this.isPreviewPage
        ? process.env.LOGIN_INFO_CONF_PRE
        : process.env.LOGIN_INFO_CONF;
      post(LOGIN_INFO_CONF, up)
        .then((data) => {
          this.form = data.form || [];
          this.page_style = data.page_style;
          // new landing
          if (data.page_style === "h5_br") {
            this.setState({
              _help_icon: false,
              _help_icon_url: "",
              _help_icon_icon_url: "",
            });
          } else {
            this.handleHelpABBefore();
          }
          // 曝光埋点依赖接口返回的是新老页面
          if (changeType !== "city") {
            this.setTrackerSw();
          }
          this.form.forEach((item) => {
            if (item.key === "phone") {
              item.value = "";
            }
            if (item.key === "area_id") {
              this.hasCity = true;
            }
            if (item.type === "phone-enter-region") {
              item.list.some((i) => {
                if (i.key === "phone") {
                  item.value = "";
                }
                return i.key === "phone";
              });
              item.list.some((i) => {
                if (i.key === "area_id") {
                  this.hasCity = true;
                }
                return i.key === "area_id";
              });
            }
            if (item.type === "privacy-policy") {
              item.options.forEach(
                (option) => (option.value = option.default_select || "")
              );
            }
            if (item.type === "button" && this.isNewLandingpage) {
              item.privacy_options.forEach(
                (option) => (option.value = option.default_select || "")
              );
            }
          });
          // console.log(this.form);
        })
        .catch((err) => {
          showAlertDialog(this);
          try {
            Omega.trackEvent("ibt_register_landingpage_conf_error_st", "", {
              path_url: LOGIN_INFO_CONF, //接口url
              message: JSON.stringify(err), //全部返回信息
              request: up.toString(), //请求参数信息
              errno: err.errno, //报错码
            });
          } catch (e) {}
        })
        .finally(() => {
          // console.log(this.toast, '11');
          this.toast.hide();
        });
    },
    monitorScroll() {
      let marginBot = 0;
      if (document.compatMode === "CSS1Compat") {
        marginBot =
          document.documentElement.scrollHeight -
          (document.documentElement.scrollTop + document.body.scrollTop) -
          document.documentElement.clientHeight;
      } else {
        marginBot =
          document.body.scrollHeight -
          document.body.scrollTop -
          document.body.clientHeight;
      }
      if (marginBot <= 0) {
        Omega.trackEvent(
          "ibt_onboarding_landingpageslidebottom_sw",
          "",
          this.omegaItem
        );
      }
    },
    doLoginBr(type, waUrl) {
      // new landingpage 三个必填项判断（城市、手机号、法律条款）
      this.phoneClassError = false;
      this.areaClassError = false;
      this.policyClassError = false;
      this.policyClassCircle = false;
      if (this.isNewLandingpage) {
        if (!this.phoneNumber) {
          showToast(this, {
            type: "warn",
            txt: this.$t("GDriver_optimize_Enter_the_Qnir"),
          });
          document.documentElement.scrollTop = 0;
          // this.$refs.phone_input.focus();
          setTimeout(() => {
            this.phoneClassError = true;
          }, 200);
          if (!this._area.value) {
            setTimeout(() => {
              this.areaClassError = true;
            }, 200);
          }
          // if (!this.policy) {
          //   this.policyClassCircle = true;
          // }
          return;
        } else if (!this._area.value && this.hasCity) {
          Omega.trackEvent("gd_carType_view_sw", "", this.omegaItem);
          showToast(this, {
            type: "warn",
            txt: this.$t("GDriver_optimize_Please_choose_SJtI"),
          });
          document.documentElement.scrollTop = 0;
          setTimeout(() => {
            this.areaClassError = true;
          }, 200);
          if (!this.phoneNumber) {
            setTimeout(() => {
              this.phoneClassError = true;
            }, 200);
          }
          // if (!this.policy) {
          //   this.policyClassCircle = true;
          // }
          return;
        } else if (!this.policy) {
          this.policyClassError = true;
          if (this._area.value && this.phoneNumber.length >= 11) {
            this.policyClassCircle = true;
          }
          showToast(this, {
            type: "warn",
            txt: this.$t("GDriver_optimize_Read_and_xrQu"),
          });
          return;
        }
      }
      // @20220117 补齐广告埋点
      try {
        gtm({
          event: "s1PassportRegister",
          PhoneNumber: "valid",
          Country: "BR",
          RegisterWith: "99",
          error: "false",
        });
      } catch (e) {}

      if (this.isWhatsApp && type === "WALogin") {
        showLoadingToast(this);
        let up = new URLSearchParams(location.search);
        up.set("countryCode", this.location_country);
        up.set("phone", this.phoneNumber);
        up.set(this._open_type, this._area.value);
        if (this.product) {
          up.set("product", this.product);
        }
        if (this.identity) {
          up.set("identity", this.identity);
        }
        post(waUrl, up)
          .then((data) => {
            if (data) {
              window.location.href = data;
            }
          })
          .catch((err) => {
            Omega.trackError(
              "tech_ibt_onboarding_landingpagegetwhatsapp_bt",
              err.errno,
              err.errmsg,
              {
                url: waUrl,
                resp: err,
                desc: "new landingpage获取whatsapp接口",
              }
            );
            console.log(err);
            const { errno } = err;
            if (+errno === 400001) {
              // 当前手机号没有WA账号
              showDialog(this, {
                type: "confirm",
                icon: "cubeic-info",
                content: this.$t("GDriver_optimize_Phone_No_boYK").replace(
                  /{{phone_number}}/,
                  this.phoneNumber
                ),
                confirmBtn: {
                  text: this.$t("GDriver_optimize_Continue_KFSQ"),
                },
                cancelBtn: {
                  text: this.$t("GDriver_optimize_Modify_Phone_Ovvv"),
                },
                onConfirm: () => {
                  this.checkPhoneBr();
                },
                onCancel: () => {
                  // this.$refs.phone_input.focus();
                },
              });
            } else if (+errno === 400002) {
              // 这个产品线没有开通当前选中的城市
              let toastTip = this.$t("GDriver_optimize__FGcp").replace(
                /{{product_name}}/,
                this._product_name
              );
              showAlertDialog(this, toastTip);
            }
          })
          .finally(() => {
            this.toast.hide();
          });
      } else {
        this.checkPhoneBr();
      }
    },
    checkPhoneBr() {
      if (this._login_config && this.privacy_policy?.length > 1) {
        let c = JSON.parse(JSON.stringify(this._login_config));
        if (this.policyChoosedType && this.policyChoosedType.length > 0) {
          c.extra_info = {
            ...this._login_config.extra_info,
            chosen_terms: this.policyChoosedType,
          };
        } else {
          delete c.extra_info.chosen_terms;
        }
        login.setConfig(c);
      }

      showLoadingToast(this, this.$t("加载中"), 1500);
      document.documentElement.scrollTop = 0;
      const loginAction = (callback, fallback) => {
        return login.checkPhone(this.phoneNumber, callback, fallback);
      };
      loginAction(
        (response) => {
          const { ticket, cell, uid } = response;
          this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });
          //  注册过完passport后调用广告接口, 把广告参数和uid关联上
          this.loginSuccess(response)
          // 注册过完passport后调用端bridge, 获取用户信息
          ends.inApp &&
            Fusion &&
            Fusion.codeVerifySuccess &&
            Fusion.codeVerifySuccess({
              global_phone: `${this.phoneCountryCode}${this.phoneNumber}`,
              token: ticket,
              uid,
              role: 2,
            });

          fireBase("tone_p_x_login_success_sw");
          if (this._area.value) {
            let up = new URLSearchParams(location.search);
            //兼容各个国家情况，vuex中如果存在ticket，则优先信任
            if (this._ticket) {
              up.set("ticket", this._ticket);
            }
            up.set("area_id", this._area.value);
            post(process.env.SET_AREA_ID, up)
              .then((data) => {
                const { errno, area_name } = data;
                if (errno === 10090) {
                  showDialog(this, {
                    type: "confirm",
                    icon: "cubeic-info",
                    content: area_name
                      ? this.$t("GDriver_optimize_The_city_GkTr").replace(
                          /{{city_name}}/,
                          area_name
                        )
                      : this.$t("GDriver_optimize_You_have_eFId"),
                    confirmBtn: {
                      text: this.$t("GDriver_optimize_Determination_AIJf"),
                    },
                    cancelBtn: { text: this.$t("取消") },
                    onConfirm: () => {
                      this.$router.replace({ name: "home" });
                    },
                    onCancel: () => {
                      this.$router.replace({ name: "home" });
                    },
                  });
                } else {
                  this.$router.replace({ name: "home" });
                }
              })
              .catch((err) => {
                Omega.trackError(
                  "tech_ibt_onboarding_landingpagesetareaid_bt",
                  err.errno,
                  err.errmsg,
                  {
                    url: process.env.SET_AREA_ID,
                    resp: err,
                    desc: "new landingpage存储areaId报错",
                  }
                );
                console.log(err);
              })
              .finally(() => {
                this.toast.hide();
              });
          } else {
            this.$router.replace({ name: "home" });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    // help入口实验(passport之前的页面)
    handleHelpABBefore() {
      this.params;
      post(process.env.HELP_AB_TEST_BEFORE, this.params)
        .then((data) => {
          this.setState({
            _help_icon: data.hasHelpButton,
            _help_icon_url: data.url,
            _help_icon_icon_url: data.icon_url,
          });
        })
        .catch((err) => {
          this.setState({
            _help_icon: false,
            _help_icon_url: "",
            _help_icon_icon_url: "",
          });
        });
    },
    setTrackerSw() {
      if (this.isNewLandingpage) {
        try {
          Omega.trackEvent("ibt_onboarding_displaylandingpage_sw", "", {
            ...this.omegaItem,
            client_user_agent: navigator.userAgent, // 必须
            fbp: this.$cookies.get("_fbp"), // 可选，可能有多个，需要和domain匹配
            fbc: this.$cookies.get("_fbc"), // 可选，可能有多个或没有，需要和domain匹配
          });
          gtm({
            event: "pageview",
            error: "false",
          });
        } catch (e) {}
      } else {
        try {
          Omega.trackEvent("tone_p_x_account_loginnew_sw", "", {
            ...this.omegaItem,
            client_user_agent: navigator.userAgent, // 必须
            // client_ip_address: '', // 可选
            fbp: this.$cookies.get("_fbp"), // 可选，可能有多个，需要和domain匹配
            fbc: this.$cookies.get("_fbc"), // 可选，可能有多个或没有，需要和domain匹配
          });
          gtm({
            event: "pageview",
            error: "false",
          });
        } catch (e) {}
      }
    },
    loginSuccess(data) {
      if (!data) {
        return
      }
      const event = new CustomEvent("login-sms-success", { detail: { data } });
      window.dispatchEvent(event);
    }
  },
  mounted() {
    setTimeout(this.getPageConfig, 0);
    try {
      computeJumpTime(this);
    } catch (error) {}
    window.addEventListener("scroll", this.monitorScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.monitorScroll, true);
    try {
      computeStayTime(this);
    } catch (error) {}
  },
  components: {
    HomeBanner,
    PhoneInput,
    Policy,
    RegisterBtn,
    BottomSelect,
    WAHeader,
    WAFooter,
    MultiBanner,
    Banner,
    CitySelect,
    ImgLink,
    DriverInfo,
    BottomIcon,
    DgdBanner,
    CustomBanner,
    // StayPop
  },
};
</script>
<style lang="scss" scoped>
@import "../css/var.scss";
@import "../css/mixin.scss";
.home {
  position: relative;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background: #fff;
  font-size: 0.36rem;
  // touch-action: none;
  &.home-br {
    padding-bottom: 3rem;
    background: #eaeaec;
    ::v-deep .point-warpper {
      margin-bottom: 1.2rem;
    }
    ::v-deep .contact-info-wrapper {
      hr {
        display: none;
      }
      .contact-info-item-wrapper {
        // padding: 0.2rem 0 0 0;
        padding: 0;
      }
    }
  }
  > div.has-padding {
    padding: 0 0.4rem 0.4rem 0.4rem;
  }
  .guarantee-banner {
    width: 100%;
    padding: 0 0.36rem;
    box-sizing: border-box;
    .img-container {
      margin-top: 0;
      ::v-deep .img-text {
        width: 100%;
        padding: 0 0.24rem 0 0.8rem;
        box-sizing: border-box;
        color: #18c47c;
        font-size: 0.22rem;
        font-weight: 700;
        line-height: 0.25rem;
      }
    }
  }
}
</style>
